import React from 'react'

import { withError } from 'utils/withError'

import { BoxPriceBlock } from '../BoxPriceBlock'
import { BoxPricesListProps } from './boxPricesListModels'

import css from './BoxPriceList.css'

const BoxPricesList = ({ numPersonsToBoxDescriptors, selectedBox }: BoxPricesListProps) => (
  <div className={css.boxPriceList}>
    {Object.entries(numPersonsToBoxDescriptors).map(([numPersonsStr, boxDescriptors]) => {
      const key = `box-type-${numPersonsStr}`
      const numPersons = parseInt(numPersonsStr, 10)

      return (
        <BoxPriceBlock
          key={key}
          numPersons={numPersons}
          boxInfo={boxDescriptors}
          selectedBox={selectedBox}
        />
      )
    })}
  </div>
)

export const BoxPricesListContainer = withError(BoxPricesList)
